import { disableScroll, enableScroll } from '../utils/scrollDisabler';

//  Polyfill startsWith
if (typeof String.prototype.startsWith != 'function') {
    String.prototype.startsWith = function (str) {
        return this.slice(0, str.length) == str;
    };
}
// ------------------------------------------------------------------------
// STATE
// ------------------------------------------------------------------------
const state = {
    modalState: false,
};


// ------------------------------------------------------------------------
// MUTATIONS
// ------------------------------------------------------------------------
const mutations = {
    setModal(state, modalState) {
        state.modalState = modalState

        for (let i = document.body.classList.length - 1; i >= 0; i--) {
            const className = document.body.classList[i];
            if (className.startsWith('has-modal')) {
                document.body.classList.remove(className);
            }
        }

        if (state.modalState) {
            document.body.classList.add('has-modal-' + modalState)
            disableScroll();
        } else {
            enableScroll();
        }

    },
};


// ------------------------------------------------------------------------
// ACTIONS
// ------------------------------------------------------------------------
const actions = {

};


// ------------------------------------------------------------------------
// GETTERS
// ------------------------------------------------------------------------
const getters = {

};


export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
